
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import VBanner from "@/components/vBanner.vue";

@Component({
  components: {VBanner}
})
export default class vModal extends Vue {
  @Prop() show!: boolean;
  @Prop() modalTitle!: string;
  @Prop() size?: string;
  @Prop() modalId?: string;
  @Prop() modelMessage?: string;
  @Prop({ default: "" }) modalClass!: string;
  @Prop({ default: false }) hideInPrint: boolean;
  @Prop({ default: true }) centered: boolean;
  @Prop({ default: false }) appendToBody: boolean;
  @Prop({ default: false }) interceptBannerLinks: boolean;

  @Watch("show")
  showModal() {
    let htmlBodyElement = document.getElementsByTagName("body")[0];
    if (this.show) {
      htmlBodyElement.classList.add("modalOpen");
      this.$emit("openModal");
      this.appendModalToBody();
    }

    else {
      htmlBodyElement.classList.remove("modalOpen");
    }
  }

  appendModalToBody() {
    if (!this.appendToBody || !this.show) {
      return;
    }

    this.$nextTick(() => {
      const modalElement = this.$el;

      if (modalElement && modalElement.parentElement !== document.body) {
        document.body.appendChild(modalElement);
      }
    });
  }

  hideModal() {
    this.$emit("hideModal");
  }

  cancelModal() {
    this.$emit("cancelModal");
  }

  handleBannerClick(event: MouseEvent) {
    if (!this.interceptBannerLinks) {
      return;
    }

    const target = event.target as HTMLElement | null;
    const anchor = target?.closest("a");
    if (!anchor) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.$emit("bannerLinkClick", anchor.getAttribute("href"));
  }

  mounted() {
    this.appendModalToBody();

    document.addEventListener("keydown", (e) => {
      if (this.show && e.keyCode == 27) {
        this.cancelModal();
      }
    });
  }

  beforeDestroy() {
    if (this.appendToBody && this.$el && this.$el.parentElement === document.body) {
      document.body.removeChild(this.$el);
    }
  }
}
